module.exports = __webpack_public_path__ + "static/media/it3.694c5773.png";